import { Link } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import { HERO_IMAGES } from "../lib/constants";

export default function Nebraska() {
    return (
        <PageLayout>
            <section className="relative min-h-[70vh] flex items-end pb-16 pt-32 overflow-hidden border-b border-white/10">
                <img src={HERO_IMAGES.stadium_lights} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
                <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-6">Nebraska Launch</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-[0.95] tracking-tight" data-testid="nebraska-heading">
                        THE DIGITAL BEAST<br/>MOVEMENT BEGINS IN<br/><span className="text-[#d4af37]">NEBRASKA.</span>
                    </h1>
                    <p className="mt-6 max-w-3xl text-white/70 text-lg leading-relaxed">
                        We're building relationships with football players, families, local businesses and supporters in the Nebraska athletic community — starting with athletes connected to the University of Nebraska–Lincoln football program.
                    </p>
                </div>
            </section>
            <section className="py-16">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid md:grid-cols-2 lg:grid-cols-5 gap-3">
                    {[
                        ["Request an Athlete Consultation", "/contact"],
                        ["Become a Nebraska Brand Partner", "/brands"],
                        ["Invite Digital Beast to Speak", "/contact"],
                        ["Sponsor a Local Athlete", "/brands"],
                        ["Join the Digital Beast Network", "/apply"],
                    ].map(([l, to], i) => (
                        <Link key={l} to={to} className="btn-outline justify-center" data-testid={`nebraska-page-cta-${i}`}>{l}</Link>
                    ))}
                </div>
                <div className="max-w-3xl mx-auto px-5 mt-16 text-white/50 text-xs text-center leading-relaxed border-t border-white/10 pt-8">
                    Disclaimer: Digital Beast is an independent business and is not claiming official affiliation, endorsement or partnership with the University of Nebraska, Nebraska Athletics or the Cornhuskers unless a written agreement is secured.
                </div>
            </section>
        </PageLayout>
    );
}
